/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { supportedVariableNamespaces } from './variables-namespace-registry';

/**
 * @import { IVariablesNamespaceRegistry, VariableRef, VariablesValue } from '.'
 */

const sep = '.';

/**
 * @param {VariableRef} varName
 * @returns {[string, string]}
 */
export function extractNsValue(varName) {
  const [ns, ...rest] = varName.split(sep);
  return [ns, rest.join(sep)];
}

/**
 * @param {string} value
 * @returns {value is VariableRef}
 */
export function isVariableRef(value) {
  return supportedVariableNamespaces.some((ns) => value.startsWith(`${ns}.`));
}

/**
 * @param {VariableRef} left  napr. 'info.someKey'
 * @param {IVariablesNamespaceRegistry} registry
 * @returns {VariablesValue | undefined}
 */
export function resolveVar(left, registry) {
  const [ns, key] = extractNsValue(left);
  return registry.get(ns)?.getValue(key);
}
